import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { AnnouncementDialogComponent } from "./announcement-dialog.component";

@NgModule({
	imports: [CommonModule, FormsModule],
	declarations: [AnnouncementDialogComponent],
	exports: [AnnouncementDialogComponent]
})
export class AnnouncementDialogModule { }
